
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M7 12.505v-4.5h1.591c.778 0 1.409.692 1.409 1.477s-.676 1.523-1.454 1.523H7.25M3.833 16h8.334c.46 0 .833-.392.833-.875v-8.71a1 1 0 0 0-.293-.708L9.293 2.293A1 1 0 0 0 8.586 2H3.833C3.373 2 3 2.392 3 2.875v12.25c0 .483.373.875.833.875"}})])
          )
        }
      }
    